import type { ResearchReportSummary } from "@roboscientist/contracts";

const timestamp = (value: string): number => {
  const parsed = Date.parse(value);
  return Number.isFinite(parsed) ? parsed : Number.NEGATIVE_INFINITY;
};

export const sortResearchReports = <T extends ResearchReportSummary>(reports: readonly T[]): T[] =>
  [...reports].sort((left, right) =>
    timestamp(right.publishedAt) - timestamp(left.publishedAt)
    || right.reportId.localeCompare(left.reportId)
  );

export const reportKindLabel = (kind: ResearchReportSummary["kind"]): string =>
  kind === "final" ? "Final" : "Interim";

export const formatReportTimestamp = (value: string): string => {
  const parsed = new Date(value);
  if (!Number.isFinite(parsed.getTime())) return "Unavailable";
  return parsed.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });
};
